import React from 'react'
import moment from 'moment'
import { isNull } from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, branch, renderComponent } from 'recompose'
import { FormattedMessage } from 'react-intl'

import { get } from '../store/reducers/static'
import { fetchingState } from '../helpers/hocs.js'
import { makeGetDoc } from '../selectors/static.js'

import NotFound from './404'

const StaticPage = ({ data }) => {
  if (!data) return null
  const date = moment(data.date)

  return (
    <div className='Container Container_top-negative'>
      <div className='Sidebar Sidebar_privacy'>
        <div className='Sidebar__body Sidebar__body_privacy'>
          <h1 className='Sidebar__head Sidebar__head_privacy'>{data.title}</h1>
          <span className='Label'>
            <FormattedMessage id='static.last_modified' />
            {': '}
            {date.format('D MMMM YYYYг.')}
          </span>
        </div>
      </div>
      <div className='Main Main_privacy' dangerouslySetInnerHTML={{ __html: data.text }} />
    </div>
  )
}

const mapStateToProps = () => (state, props) => ({
  data: makeGetDoc()(state, props),
  currentLocale: state.intl.locale
})

const mapDispatchToProps = dispatch => bindActionCreators({ get }, dispatch)
const mergeProps = (state, { get }, { alias, fetchingWrap, on404, ...props }) => ({
  ...state,
  ...props,
  alias,
  get: async (newAlias, noLoader = true) => {
    alias = newAlias || alias
    if (!alias) return
    const result = noLoader ? await get(alias) : await fetchingWrap(get.bind(this, alias))
    if (result !== 200 && result !== 301) on404()
  }
})

export default compose(
  branch(({ alias }) => !alias, renderComponent(NotFound)),
  fetchingState(),
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  lifecycle({
    componentWillMount () {
      if (!this.props.data) this.props.get()
    },
    componentWillReceiveProps (np) {
      if (np.alias !== this.props.alias) this.props.get(np.alias, false)
    }
  }),
  branch(({ data }) => isNull(data), renderComponent(NotFound))
)(StaticPage)



// WEBPACK FOOTER //
// ./src/containers/Static.jsx